import { render } from "./Partners.vue?vue&type=template&id=7f7eee06&scoped=true"
import script from "./Partners.vue?vue&type=script&lang=js"
export * from "./Partners.vue?vue&type=script&lang=js"

import "./Partners.vue?vue&type=style&index=0&id=7f7eee06&scoped=true&lang=css"

import exportComponent from "E:\\workspace\\digital-gate\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f7eee06"]])

export default __exports__